<template>
  <Icon
    name="more"
    :width="18"
    :height="20"
    :scale="25"
  >
    <path d="M51,153c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S79.05,153,51,153z M357,153c-28.05,0-51,22.95-51,51
      s22.95,51,51,51s51-22.95,51-51S385.05,153,357,153z M204,153c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51
      S232.05,153,204,153z"/>
  </Icon>
</template>

<script>
  import Icon from "../Elements/Icon";

  export default {
    name: 'More',

    components: { Icon },
  };
</script>